export class CostReviewChillerPlant {
  numberOfChillers!: number;
  manufacturerChillers!: string;
  driversChiller!: number;
  chillersControlsFurnishedBy!: number;
  chillersControlsInstalledBy!: number;
  chillersControlsWiredBy!: number;
  numberOfTowers!: number;
  manufacturerTowers!: string;
  driversTowers!: number;
  towersControlsFurnishedBy!: number;
  towersControlsInstalledBy!: number;
  towersControlsWiredBy!: number;
  numberOfPumps!: number;
  manufacturerPumps!: string;
  driversPumps!: number;
  pumpsSensorsFurnishedBy!: number;
  pumpsSensorsInstalledBy!: number;
  pumpsSensorsWiredBy!: number;
  isChillerPlantApplicable!: boolean;
}
